export * from "./modal-result.component";
